<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Heading from '../../layouts/heading.vue';
// import Swal from "sweetalert2";
// import { v4 as uuidv4 } from 'uuid';
import api from "../../../api";
// import JsonForm from "../../layouts/form";
// import Switches from "vue-switches";
import Multiselect from "vue-multiselect";

export default {
  page: {
    title: "Audit",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, Heading, Multiselect },
  data() {
    return {
      dates: null,
      selectedPractice: null,
      startDate: null,
      endDate: null,
      practices: [],
      enabled: true,
      auditLog: null,
      page: {
        title: "Audit",
        lastUpdated: false,
        addNewBtn: false,
        addNewModalTitle: 'Create New Page',
        table: {
          rows: {},
          tableCols: [
            { key: "name", type: "", sortable: false },
            { key: "CREATE", type: "checkbox", sortable: false },
            { key: "READ", type: "checkbox", sortable: false },
            { key: "UPDATE", type: "checkbox", sortable: false },
            { key: "UPDATEMANY", type: "checkbox", sortable: false },
            { key: "DELETE", type: "checkbox", sortable: false },
            { key: "LIST", type: "checkbox", sortable: false },
            { key: "COUNT", type: "checkbox", sortable: false },
            { key: "EXECUTE", type: "checkbox", sortable: false },
            { key: "AccessAuthFeature", type: "checkbox", sortable: false },
          ],
        },
        formData: {
          isAdmin: {
            'Admin': false
          },
          permissions: {}
        },
        schema: {
          name: {
              type: 'text',
              label: 'Name',
              placeholder: 'Enter Name',
              required: true,
              info: false,
              character_count: 50
          },
          email: {
              type: 'text',
              label: 'Email',
              placeholder: 'Enter Email',
              required: true,
              info: false,
              character_count: 50
          },     
          // password: {
          //     type: 'password',
          //     label: 'Password',
          //     placeholder: 'Enter Password',
          //     required: true,
          //     info: false,
          //     character_count: 0
          // },
          // isAdmin: {
          //     type: 'checkbox',
          //     label: 'Only for Admin Access',
          //     options: ['Admin'],
          //     placeholder: '',
          //     required: false,
          //     info: false,
          //     character_count: 0
          // },          
          role: {
              type: 'select',
              label: 'Role',
              options: [],
              placeholder: '',
              required: false,
              info: false,
              character_count: 0
          },
          // permissions: {
          //     type: 'button',
          //     label: 'Permissions',
          //     // placeholder: 'Enter Password',
          //     // required: false,
          //     // info: false,
          //     // character_count: 0
          // },        
        },
        editSchema: {
          name: {
              type: 'text',
              label: 'Name',
              placeholder: 'Enter Name',
              required: true,
              info: false,
              character_count: 50
          },
          // email: {
          //     type: 'text',
          //     label: 'Email',
          //     placeholder: 'Enter Email',
          //     required: true,
          //     info: false,
          //     character_count: 50,
          //     disabled: true
          // },   
          role: {
              type: 'select',
              label: 'Role',
              options: [],
              placeholder: '',
              required: false,
              info: false,
              character_count: 0
          },
          // password: {
          //     type: 'password',
          //     label: 'Password',
          //     placeholder: 'Enter Password',
          //     required: true,
          //     info: false,
          //     character_count: 0
          // },
          // isAdmin: {
          //     type: 'checkbox',
          //     label: 'Only for Admin Access',
          //     // options: ['Admin'],
          //     placeholder: '',
          //     required: false,
          //     info: false,
          //     character_count: 0
          // },
          // permissions: {
          //     type: 'button',
          //     label: 'Permissions',
          //     // placeholder: 'Enter Password',
          //     // required: false,
          //     // info: false,
          //     // character_count: 0
          // },        
        },
        disBtn: false,
        deleteBtn: false,
        activeBtn: false,
        submitBtn: false,
        searchBox: false
      },      
      items: [
        {
          text: "Tables",
          href: "/"
        },
        {
          text: "Advanced",
          active: true
        }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "userName", label: "User", sortable: true },
        { key: "action", sortable: true },
        // { key: "component", sortable: true },
        { key: "categoryName", label: "Category", sortable: true },
        // { key: "entityId", sortable: false },
        { key: "entityTitle", label: "Item", sortable: true },
        { key: "actedAt", label: "Date & Time", sortable: true },
        { key: "ipAddress", label: "IP Address", sortable: true },

        // { key: "actedOn", sortable: false },
        // { key: "practiceId", sortable: true },
        // { key: "practiceName", sortable: true },
        // { key: "actionMethod", sortable: false },
        // { key: "userId", sortable: false },
      ],
    };
  },
  computed: {
    /**
     * Total no. of records
     */
    // currentUser() {
    //   return JSON.parse(localStorage.getItem('currentUser'));
    // },
    rows() {
      if(this.auditLog)
      {
        return this.auditLog.length;
      }
      else
      {
        return 0
      }
    },
    disableFetch() {
      if(!this.selectedPractice || !this.selectedPractice.id || !this.startDate || !this.endDate) return true
      return false
    },
  },
  methods: {
    updateFilter(value) {
      this.filter = value
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    async getAuditLog(selectedPracticeId, startDate, endDate) {
      try {
        let filter = {
          "where": {
            "practiceId": selectedPracticeId,
            "actedAt": {between: [startDate, endDate]}
          }
        };
        filter = encodeURIComponent(JSON.stringify(filter));
        const {data} = await api.get(`/audits?filter=${filter}`)
        this.auditLog = data
      } catch (e) {
        console.log(e)
      }
    },
    rowClass() {
      return 'table-light'
    },
    async getUserPractices() {
      let url = `/api/practices`
      try {
        const {data} = await api.get(url)
        this.practices = data.sort((a, b) => a.name.localeCompare(b.name))
      } catch (e) {
        console.log(e)
      }      
    },
    async fetchAuditLogs() {
        this.auditLog = []
        this.getAuditLog(this.selectedPractice.id, this.startDate, this.endDate)
    },
    formatAction(string) {
      if(string === 'POST') return 'Create'
      if(string === 'PATCH') return 'Update'
      if(string === 'DELETE') return 'Delete'
      return string
    },
    formatCatName(string) {
      if(string === 'patientnews') return 'news'
      return string
    },
    capitalizeFirstLetter(string) {
      if(string && string.length) {
        const cat = this.formatCatName(string)
        return cat.charAt(0).toUpperCase() + cat.slice(1);
      }
      return ''
    }
  },
  mounted() {
    this.totalRows = this.items.length; 
    this.getUserPractices()
  },
};
</script>

<template>
  <Layout>
    <Heading :page="page" @filter="updateFilter"></Heading>

    <div class="row mt-4">
      <div class="col-4">
        <multiselect
            track-by="name"
            label="name"
            v-model="selectedPractice"
            :options="practices"
            :searchable="practices.length > 5 ? true : false"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Select Practice"
            :allow-empty="false"
            :preselectFirst="true"
        >
            <template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.name }}</strong></template>
        </multiselect>  
      </div>
      <div class="col-3">
        <input
            v-model="startDate"
            type="date"
            class="form-control"
        />
      </div>
      <div class="col-3">
        <input
            v-model="endDate"
            type="date"
            class="form-control"
        />
      </div>
      <div class="col-2">
        <button class="btn btn-primary w-100 rounded-0" :disabled="disableFetch" @click="fetchAuditLogs">Find</button>
      </div>
    </div>

    <hr>

    <div class="row">
      <div class="col-12">
        <div class="mt-3">
          <div class="d-flex">
          </div>
          <!-- Table -->
          <div id="user-table" class="table-responsive mb-0">
            <b-table
              :items="auditLog"
              :fields="fields"
              responsive="sm"
              :per-page="perPage"
              :current-page="currentPage"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              @filtered="onFiltered"
              tbody-tr-class="table-light font-size-16 border-bottom-light"
            >
            <template v-slot:cell(actedAt)="row">
              <div class="font-size-16">
                {{ new Date(row.item.actedAt).toDateString() }},
                {{ new Date(row.item.actedAt).toLocaleTimeString('UTC', {hour: 'numeric', minute: 'numeric'}) }}
              </div>
            </template>
            <template v-slot:cell(action)="row">
              <div class="font-size-16">
                {{ formatAction(row.item.action) }}
              </div>
            </template>
            <template v-slot:cell(categoryName)="row">
              <div class="font-size-16">
                {{ capitalizeFirstLetter(row.item.categoryName) }}
              </div>
            </template>
            </b-table>
          </div>
          <div class="row">
            <div class="col">
              <div class="dataTables_paginate paging_simple_numbers float-right">
                <ul class="pagination pagination-rounded mb-0">
                  <!-- pagination -->
                  <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.table td {
  border-top: 1px solid #dadce3 !important;
}
.table th {
  border-top: 1px solid #dadce3 !important;
}
.table-light {
  /* background-color: white; */
  padding: 50px;
}

</style>